import mixins from '@synergycms_core/less/mixins.js';

export default {
    engineFileContainer:{},
    promoWiMode:{},
    portalDesign:{},
    dateContainer:{},
    dateBoxContent:{},
    iconsEngine:{},
    dispoModal:{},
    inOutDate:{},
    inOutDateEnd: {},
    dateSeparator: {},
    inputEngineTitle:{},
    dateBoxText:{},
    dateSelectedBackground:{},
    selectedDate:{},
    dateBoxTextAlone:{},
    DESK :{},
    MOBIL:{},
    TABLET:{},
    dateText:{},
    defaultStyle: data => ({
        color: '#000',
        position: 'relative',
        marginBottom: '10px',
        outline: 'none',
        [`@media (min-width: ${data.modalBreak}px)`]: {
            //width: '24.5%',
            width: '26.5%',
            verticalAlign: 'middle',
            display: 'table-cell',
            '&$roundedTheme':{
                '& $dateContainer':{
                    borderRadius: 'unset',
                }
            }
        },
        '&:lang(ar)': {
            [`@media (min-width: ${data.modalBreak}px)`]: {
                borderRight: 'none'
            }
        },
        '& $dateContainer':{
            backgroundColor: '#fff',
            [`@media (min-width: ${data.modalBreak}px)`]: {
                borderRight: '1px solid #d8d8d8',
                backgroundColor:'#fff',
                position:'relative',
                height:'49px'
            },
            '&:lang(ar)': {
                direction: 'rtl',
                [`@media (min-width: ${data.modalBreak}px)`]: {
                borderLeft: '1px solid #d8d8d8'
                }
            },
            '& $iconsEngine': {
                position: 'absolute',
                fontSize: '22px',
                lineHeight: '40px',
                left: '12px',
                top: 0,
                color: data.mainColor,
                [`@media (min-width: ${data.modalBreak}px)`]: {
                  lineHeight: '50px'
                },
                '&:lang(ar)': {
                  left: 'auto',
                  right: '12px'
                }
            },
            '& $dateBoxContent': {
                padding: '5px 10px 5px 40px',
                display: 'flex',
                gap: '16px',
                position: 'relative',
                cursor: 'pointer',
                alignItems: 'center',
                font: '300 13px ' + data.fontFamily1,
                minHeight: '40px',
                outline: 'none',
                ...mixins.boxSizing(),
                [`@media (min-width: ${data.modalBreak}px)`]: {
                    paddingRight: '5px',
                    minHeight:'49px',
                },
                '&:lang(ar)': {
                    paddingLeft: '70px',
                    paddingRight: '40px',
                    [`@media (min-width: ${data.modalBreak}px)`]: {
                        paddingRight: '40px',
                        paddingLeft: '5px'
                    }
                },
                '& $inOutDate': {
                    position: 'relative',
                    width: 'max-content',
                    padding: '0 0 0 7px',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    '&:lang(ar)': {
                      textAlign: 'right',
                      padding: '0 7px 0 0'
                    },
                    [`@media (min-width: ${data.modalBreak}px)`]:{
                      height:'24px',
                    },
                    '@supports (-webkit-appearance:none)': {
                        [`@media (min-width: ${data.modalBreak}px)`]:{
                        height:'auto',
                      }
                    },
                    '&$dateSelectedBackground': {
                        marginRight: '5px',
                        minHeight: '30px',
                        backgroundColor: 'rgba(216,216,216,.4)',
                        boxSizing: 'border-box',
                        [`@media (min-width: ${data.modalBreak}px)`]: {
                          minHeight: '39px'
                        },
                        '&:lang(ar)': {
                          marginLeft: '5px',
                          marginRight: 0
                        }
                    },
                    '& $dateBoxText': {
                        display: 'block',
                        position: 'absolute',
                        top: '50%',
                        left: '7px',
                        right: '0',
                        transition: 'top .3s',
                        lineHeight: '1px',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        '&:lang(ar)': {
                          left: 'auto',
                          right: '7px'
                        },
                        '&$dateBoxTextAlone': {
                            top: '1px',
                            marginTop: 0,
                            lineHeight: '10px'
                        },
                    },
                    '& $dateText': {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    },
                },
                '& $inOutDateEnd': {
                    paddingLeft: '0px',
                    display: 'flex',
                    alignItems: 'center'
                }
            },
            '& $inputEngineTitle':{
                font: '600 12px/13px ' + data.fontFamily1,
                letterSpacing:'1.54px',
                textTransform:'uppercase',
                display:'block',
                paddingLeft:'40px',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                color:'#4a4a4a',
                [`@media (min-width: ${data.modalBreak}px)`]:{
                    paddingLeft:'13px',
                    paddingTop:'13px',
                    '&:lang(ar)':{
                        paddingLeft: '0',
                        paddingRight: '13px',
                        textAlign: 'right',
                    }
                }
            }
        },
        '&$engineFileContainer':{
            [`@media (min-width: ${data.modalBreak}px)`]: {
                //width:'26.5%'
                width:'31.5%',
                '&$roundedTheme':{
                    '& $dateContainer':{
                        borderRadius: '25px 0 0 25px',
                    }
                }
            }
        },
        '&$promoWiMode':{
            [`@media (min-width: ${data.modalBreak}px)`]: {
                width:'31.5%'
            },
            '& $dateContainer':{
                '& $dateBoxContent':{
                    '& $inOutDate':{
                        //minWidth:'125px'
                    },
                }
            }
        },
        '&$portalDesign':{
            '&:not($dispoModal)':{
                marginBottom:0,
                [`@media (max-width: ${data.modalBreak - 1}px)`]:{
                    width: 'calc( 100% - 90px)',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                },
                '& $dateContainer':{
                    height:'55px',
                    display:'flex',
                    alignItems:'center',
                    '&:lang(ar)':{
                    justifyContent: 'flex-start',
                    },
                    [`@media (min-width: ${data.modalBreak}px)`]:{
                    height:'80px',
                    display:'block'
                    },
                    '& $dateBoxContent':{
                        minHeight:'55px',
                        [`@media (min-width: ${data.modalBreak}px)`]:{
                            minHeight:'54px',
                            color:'#7f7f7f',
                            fontSize:'15px',
                        },
                        '&$engineMerged':{
                            '@media (max-width: 1199px)':{
                                gap: '5px',
                                flexDirection: 'column',
                                gap: '5px',
                                alignItems: 'flex-start',
                                '& $dateSeparator':{
                                    display: 'none',
                                },
                                '& $inOutDateEnd':{
                                    paddingLeft: '7px',
                                }
                            }
                        }
                    }
                },
                '& $iconsEngine':{
                    lineHeight:'55px',
                    top:'auto',
                    bottom:0,
                    [`@media (min-width: ${data.modalBreak}px)`]:{
                        lineHeight:'54px'
                    }
                },
            },
            [`@media (min-width: ${data.modalBreak}px)`]:{
                width:'22.5%'
            },
            '& $dateContainer':{
                '&:not($dispoModal)':{
                    '& $dateBoxContent':{
                        '& $inOutDate':{
                            '&$dateSelectedBackground':{
                                [`@media (min-width: ${data.modalBreak}px)`]:{
                                    minHeight:'32px'
                                }
                            },
                        },
                    },
                },
                '& $inputEngineTitle':{
                    textAlign:'left',
                    '&:lang(fr)':{
                    '@media (max-width: 800px)':{
                        whiteSpace:'normal'
                    }
                    },
                    '&:lang(ru)':{
                    '@media (max-width: 800px)':{
                        whiteSpace:'normal'
                    }
                    },
                    '&:lang(ar)':{
                    paddingLeft: '13px',
                    paddingRight: '13px',
                    textAlign: 'right',
                    }
                },
                '&$dateContainerDispo':{
                    '& $dateSeparator': {
                    '@media (min-width: 801px) and (max-width: 1000px)': {
                        display: 'none'
                    },
                    },
                    '& $dateBoxContent': {
                        '@media (min-width: 801px) and (max-width: 1000px)': {
                            flexDirection: 'column',
                            gap: '0',
                            alignItems: 'flex-start',
                            paddingLeft: '45px',
                            justifyContent: 'center'
                        },
                        '& $inOutDate': {
                            '@media (min-width: 801px) and (max-width: 1000px)': {
                                paddingLeft: '0',
                            },
                        }
                    }
                }
            },
        },
    }),
    inputEnter: {
        transition: 'max-height 0ms ease-out',
        maxHeight: '0',
        transitionDelay: '.3s',
        marginBottom: 0
    },
    inputEnterActive: {
        maxHeight: '100px',
        transition: 'max-height 300ms ease-out,margin-bottom .3s ease-out',
        overflow: 'hidden',
        transitionDelay: '.3s',
        marginBottom: '10px'
    },
    inputLeave: {
        maxHeight: '100px',
        transition: 'max-height 300ms ease-out',
        overflow: 'hidden'
    },
    inputLeaveActive: {
        transition: 'max-height 0 ease-out',
        marginBottom: '0',
        maxHeight: '0'
    },
    roundedTheme:{
        '& $dateContainer':{
            borderRadius: '25px',
            '& $iconsEngine': {
                fontSize: '18px'
            }
        }
    },
    dateContainerDispo:{},
    engineMerged:{},
};